import type { StatusPresetMap } from './types'

export type ContainerStatus = 'empty' | 'loaded' | 'sealed'

export const containerStatusPresets: StatusPresetMap<ContainerStatus> = {
  empty: { label: 'Empty', tone: 'neutral' },
  loaded: { label: 'Loaded', tone: 'info' },
  sealed: { label: 'Sealed', tone: 'success' },
}
